import { useFieldArray } from "vee-validate"
import type { Ref } from "vue"
export const useUniqueFieldArray = <TValue>(
  arrayPath: string | Ref<string>
) => {
  const {
    fields,
    remove,
    push: push_,
    ...fieldArrayReturn
  } = useFieldArray<TValue>(arrayPath)

  const getIndexForValue = (valueToFind: TValue) =>
    unref(fields).findIndex(
      ({ value }) => value === valueToFind
    )
  const removeByValue = (value: TValue) => {
    const index = getIndexForValue(value)
    if (index === -1) return
    return remove(index)
  }

  const push = (value: TValue) => {
    if (isValueInArray(value)) return
    return push_(value)
  }

  const isValueInArray = (value: TValue) =>
    Boolean(getIndexForValue(value) !== -1)

  return {
    fields,
    remove,
    removeByValue,
    push,
    isValueInArray,
    ...fieldArrayReturn,
  }
}
